export enum CfmTransferOrderStatus {
  Pending = "pending",
  Confirmed = "confirmed",
}
